import React, { useEffect, useState } from "react";
import notify from "devextreme/ui/notify";
import Form, {
    SimpleItem,
    GroupItem,
    Label,
    EmptyItem,
} from "devextreme-react/form";
import { Button } from "devextreme-react";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import { inserirOuAtualizar, criarContribuinteDs } from "../../DataSources";
import Memoria from "../../Memoria";
import { LoadIndicator } from "devextreme-react/load-indicator";
import ShowError from "../../AppServices";
import api from "../../api-axios";
import { useHistory } from "react-router-dom";


const FundamentoLegalForm = (props) => {

    const template = {
        id: undefined,
        prefeituraId: undefined,
        sequencial: undefined,
        origem: "",
        classificacao: "",
        textoSingular: "",
        textoPlural: "",
        nomeOficialTributo: "",
        loadIndicatorVisivel: false,
        textoBotao: "Salvar",
        _uiCarregando: false,
        _uiTextoBotao: "Carregando...",

    };

    template.prefeituraId = UserInfo.getPrefeitura();

    const [state, setState] = useState(template);

    const history = useHistory();

    useEffect(() => {
        if (props.match.params.id !== undefined) {

            setState({ ...state, _uiCarregando: true, _uiTextoBotao: "Carregando..." });

            api.get(`fundamento_legal/${UserInfo.getPrefeitura()}/${props.match.params.id}`)
            .then(response => {
                setState({ ...state, ...response.data, _uiCarregando: false });
            })
            .catch(error => {
                ShowError(error.response.data);
                history.goBack();
            });
            
                

        } else {
            setState({ ...template, _uiCarregando: false });
        }
    }, []);

    const ok = async () => {

        setState({ ...state, loadIndicatorVisivel: true, _uiTextoBotao: "Salvando...", });

        const entidade = {
            ...state,
            prefeituraId: UserInfo.getPrefeitura()
        };

        let response;

        try {
            if (!entidade.id || entidade.id === 0) {
                response = await api.post("fundamento_legal", entidade);
            }
            else {
                response = await api.put("fundamento_legal", entidade);
            }

            history.push("/fundamento_legal");
        }
        catch (error) {
            console.log(error);
            // ShowError(error.response.data);
            setState({ ...state, loadIndicatorVisivel: false, textoBotao: "Salvar" });
        }


    }

    const cancel = () => {
        notify("Operação cancelada", "warning");
        history.goBack();
    }

    if (state._uiCarregando) {
        return (
            <div className={"content-block dx-card responsive-paddings"}>
                <div
                    style={{
                        display: "flex",
                        marginTop: "25px",
                        justifyContent: "center",
                        alignContent: "center",
                        justifyItems: "center",
                        alignItems: "center",
                    }}
                >
                    <LoadIndicator width={60} height={60} />
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className={"content-block dx-card responsive-paddings"}>
                <form>
                    <Form formData={state} colCount={2}>

                        <SimpleItem dataField={"id"} colSpan={2} editorOptions={{ readOnly: true }}>
                            <Label text="ID" />
                        </SimpleItem>

                        <SimpleItem dataField={"origem"} colSpan={2}>
                            <Label text="Origem" />
                        </SimpleItem>

                        <SimpleItem
                            dataField={"classificacao"}
                            colSpan={2}
                        >
                            <Label text="Classificação" />

                        </SimpleItem>
                        <SimpleItem
                            dataField={"textoSingular"}
                            colSpan={2}
                            editorType={"dxTextArea"}
                            editorOptions={{height: 100}}
                        >
                            <Label text="Texto Singular" />

                        </SimpleItem>

                        <SimpleItem dataField={"textoPlural"} colSpan={2} editorType={"dxTextArea"} editorOptions={{height: 100}}>
                            <Label text="Texto Plural" />
                        </SimpleItem>

                        <SimpleItem dataField={"nomeOficialTributo"} colSpan={2}>
                            <Label text="Tributo" />
                        </SimpleItem>
                    </Form>

                    <div
                        style={{
                            marginTop: "10px",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <div style={{ display: "inline-block" }}>
                            <Button
                                width={120}
                                text="Salvar"
                                type="success"
                                onClick={ok}
                                disabled={state.loadIndicatorVisivel}
                            >
                                <LoadIndicator
                                    className="button-indicator"
                                    id="small-indicator"
                                    height={20}
                                    width={20}
                                    visible={state.loadIndicatorVisivel}
                                    style={{ marginRight: "10px", verticalAlign: "middle" }}
                                />
                                <span className="dx-button-text">
                                    {state.textoBotao}
                                </span>
                            </Button>
                        </div>
                        <div style={{ display: "inline-block", marginLeft: "10px" }}>
                            <Button
                                disabled={state.loadIndicatorVisivel}
                                text="Cancelar"
                                width={120}
                                onClick={cancel}
                            />
                        </div>
                    </div>
                </form>
            </div>
        </React.Fragment>
    );

}

export default FundamentoLegalForm;